export default {
  methods: {
    parseMatchers (matchers) {
      return matchers ? matchers.map(m => {
        const matcher = {
          caseInsensitive: false,
          text: ''
        }
        // eslint-disable-next-line no-unused-vars
        let [_, text, flags] = m.split('/')
        if (flags === 'i') {
          matcher.caseInsensitive = true
        }
        matcher.text = text
        return matcher
      }) : []
    },
    getRegexMatchers (matchers) {
      return matchers ? matchers.map(m => {
        let flags = ''
        if (m.caseInsensitive) {
          flags += 'i'
        }
        let text = m.text
        if (m.startsWith) {
          text = `^${text}`
        }
        if (m.endsWith) {
          text = `${text}$`
        }
        return `/${text}/${flags}`
      }) : []
    },
    getMatchersAsCommaSeparatedList (matchers) {
      return matchers ? this.parseMatchers(matchers).map(m => m.text).join(', ') : ''
    }
  }
}
